import React from 'react'
import { Phone, Mail, ArrowRight } from 'lucide-react'
import Representative from '../assets/images/data/Representative-parcel.png'

export default function NeedHelpSection () {
  return (
    <section className='w-full bg-[#f8f9fb] overflow-hidden'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center'>
          {/* LEFT CONTENT */}
          <div className='max-w-2xl z-10 py-10 sm:py-12 lg:py-16'>
            <h2 className='text-3xl sm:text-4xl lg:text-[42px] font-semibold text-[#211f57] leading-tight'>
              Need Help?
            </h2>

            {/* FEATURES */}
            <div className='mt-6 sm:mt-8 flex flex-wrap items-center gap-x-5 gap-y-3 text-xs sm:text-sm text-gray-500'>
              <span className='flex items-center gap-2'>
                <span className='text-green-600 font-bold'>✔</span>
                Pan-India Network
              </span>

              <span className='flex items-center gap-2'>
                <span className='text-green-600 font-bold'>✔</span>
                24×7 Support
              </span>

              <span className='flex items-center gap-2'>
                <span className='text-green-600 font-bold'>✔</span>
                On-Time SLA
              </span>
            </div>

            {/* DESCRIPTION */}
            <p className='mt-5 text-sm sm:text-base lg:text-lg leading-7 sm:leading-8 text-gray-500'>
              Connect with our customer support team for shipment updates,
              delivery assistance, and expert guidance on the best logistics
              solutions for your business.
            </p>

            {/* CONTACT ACTIONS */}
            <div className='mt-7 sm:mt-8 flex flex-col sm:flex-row sm:flex-nowrap items-stretch sm:items-center gap-3 sm:gap-2'>
              {/* CONTACT BUTTON */}
              <a
                href='https://sinfiniteexpress.com/contact-us'
                className='inline-flex justify-center items-center gap-2 px-6 py-3.5
      bg-[#ffcb05] text-[#211f57] font-semibold text-sm sm:text-base
      shadow-md hover:bg-yellow-300 hover:-translate-y-0.5
      transition-all duration-300 whitespace-nowrap'
              >
                Contact Us
                <ArrowRight size={18} />
              </a>

              <span className='hidden sm:block text-gray-400 text-sm'>or</span>

              {/* PHONE */}
              <a
                href='tel:+918237322531'
                className='inline-flex items-center justify-center sm:justify-start gap-2
      px-4 py-3.5 border border-gray-200 bg-white
      hover:border-[#211f57] hover:shadow-sm transition-all duration-300 whitespace-nowrap'
              >
                <Phone size={18} className='shrink-0 text-[#211f57]' />
                <span className='text-sm text-gray-700 whitespace-nowrap'>
                  +91 8237322531
                </span>
              </a>

              {/* EMAIL */}
              <a
                href='mailto:info@sinfiniteexpress.com'
                className='inline-flex items-center justify-center sm:justify-start gap-2
      px-4 py-3.5 border border-gray-200 bg-white
      hover:border-[#211f57] hover:shadow-sm transition-all duration-300 whitespace-nowrap'
              >
                <Mail size={18} className='shrink-0 text-[#211f57]' />
                <span className='text-sm text-gray-700 whitespace-nowrap'>
                  info@sinfiniteexpress.com
                </span>
              </a>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div
            className='relative hidden sm:flex justify-center lg:justify-end items-end
    h-[280px] sm:h-[340px] md:h-[380px] lg:h-[420px]'
          >
            <img
              src={Representative}
              alt='S Infinite Express delivery executive holding a parcel'
              loading='lazy'
              className='h-full w-full max-w-[340px] sm:max-w-[400px] lg:max-w-full
      object-contain object-bottom'
            />
          </div>
        </div>
      </div>
    </section>
  )
}
